import React, { useState, useEffect } from "react";

const CyberSecurityPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000); // Show after 10 seconds

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    isVisible && (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
        <div className="bg-[#111316] rounded-lg shadow-lg max-w-xl text-center relative py-20 px-5">
          <h2 className="text-xl font-bold text-white">Free Cybersecurity Consultation</h2>
          <p className="text-gray-600 mt-3">
            Protect your business with RockSec Group's advanced cybersecurity solutions. 
            Click below to schedule your free consultation now!
          </p>
          <a href="/free-consultation">
            <p className="bg-[#136690] px-10 tracking-wider py-2 md:mt-5 mt-5 text-white">
              Apply Now
            </p>
          </a>
          <button
            onClick={handleClose}
            className="absolute top-2 right-2 text-white hover:text-gray-600 text-lg px-5"
          >
            ✖
          </button>
        </div>
      </div>
    )
  );
};

export default CyberSecurityPopup;